<ejs-grid #grid class="grid-with-toolbar" width='100%' rowHeight='38' [dataSource]="fieldAssignments"
  [editSettings]="editSettings" (actionComplete)="actionComplete($event)" (actionBegin)="actionBegin($event)"
  (rowDataBound)="onRowDataBound($event)" (commandClick)="commandClick($event)">
  <ng-template #toolbarTemplate let-data>
    <ejs-toolbar>
      <e-items>
        <e-item [text]="'i18n.domain.import-configuration.edit.file.shared.set-value-to-no-data' | translate"
          prefixIcon='e-icons icon-restart' (click)="setNoDataForNonMandatoryFields()"></e-item>
      </e-items>
    </ejs-toolbar>
  </ng-template>
  <e-columns>
    <e-column headerText="" field="valid" clipMode='EllipsisWithTooltip' width="50">
      <ng-template #template let-data>
        @if(!data.valid){
          <div class="e-icons icon-warning--alt text-warning align-middle"></div>
        }
      </ng-template>
    </e-column>
    <e-column [headerText]="'i18n.domain.import-configuration.edit.file.shared.target-name' | translate"
      field="targetName" clipMode='EllipsisWithTooltip' [isPrimaryKey]='true'>
      <ng-template #template let-data>
        <span class="control-label" [ngClass]="{'required': isFieldMandatory(data)}">{{data.targetName}}</span>
      </ng-template>
    </e-column>
    <e-column field="isGroupingElement" clipMode='EllipsisWithTooltip' headerText='' width="40">
      <ng-template #template let-data>
        @if(data.isGroupingElement){
          <div class="e-icons icon-tag--group align-middle" [title]="'i18n.domain.import-configuration.edit.file.shared.grouping' | translate"></div>
        }
      </ng-template>
    </e-column>
    <e-column [headerText]="'i18n.domain.import-configuration.edit.file.shared.fkt' | translate" field="importFunction"
      clipMode='EllipsisWithTooltip'>
      <ng-template #template let-data>
        {{ImportFunction[data.importFunction]}}
      </ng-template>
    </e-column>
    <e-column [headerText]="'i18n.domain.import-configuration.edit.file.shared.source' | translate"
      field="sourceElementName" clipMode='EllipsisWithTooltip'></e-column>
    <e-column [headerText]="'i18n.domain.import-configuration.edit.file.shared.fix-value' | translate" field="fixValue"
      clipMode='EllipsisWithTooltip'></e-column>
    <!-- This column is not used at the moment -->
    <!-- <e-column [headerText]="'i18n.domain.import-configuration.edit.file.shared.cap' | translate" field="cap"
      clipMode='EllipsisWithTooltip'></e-column> -->
    <e-column headerText="" [commands]='gridCommands' width='160px'></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate let-data>
    <app-field-assignment-grid-edit-form [fieldAssignmentEditForm]="gridEditForm"
      [isColumnBased]="isColumnBased"></app-field-assignment-grid-edit-form>
  </ng-template>
</ejs-grid>
